import {useEffect, useRef, useState} from 'react';
import './App.css';
import { http } from './config/axios'
import './config/i18n'
import { GlobalStateProvider, getState} from "./components/globalState/GlobalStateProvider";
import { GlobalSaveData, GlobalState} from "./components/globalState/GlobalSaveData";
import LoadingIndicator from './components/LoadingIndicator';
import RouterCustom from './components/RouterCustom';
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import 'primeicons/primeicons.css';
import { locale, addLocale} from 'primereact/api';
import pt  from "./content/locales.json";
import { Toast } from 'primereact/toast';
import getRelatorioNotificacao from './service/getRelatorioNotificacao';

function App() {
  
  const [state, setState] = useState<any>(getState())
  const [loading, setLoading] = useState<boolean>(false)
  const initialized = useRef(false)
  const toast = useRef<Toast>(null);
  let loadingCount = 0 as number
  locale('pt');
  addLocale('pt', pt['pt'])


  const processRelatorioNotificacao = (push: any) => {
    getRelatorioNotificacao().then((data) => {
      GlobalSaveData("relatorios", data);
    });
    if(toast != null && toast.current != null){
      toast.current.show({ severity: 'info', summary: 'Mensagem', detail: push.mensagem, sticky: true });
    }
  }

  const processSaldoNotificacao = (push: any, registrado: boolean) => {
    state.user.saldo = Number(push.mensagem);
    setState({...state});
    GlobalSaveData("user", {...state.user});
    if(window.location.href.includes('/saldo-cliente')){
      window.dispatchEvent(new Event('saldoClienteAtualizar'));
    }
     if(registrado && toast != null && toast.current != null){
      toast.current.show({ severity: 'info', summary: 'Mensagem', detail: 'Seu pagamento foi registrado e o saldo foi atualizado', sticky: true });
    }
  }

  const processFaturaCancelamentoNotificacao = (push: any) => {
    if(toast != null && toast.current != null){
      const map: { [key: string]: 'success' | 'warn' | 'error' | 'info' } = {
        SUCCESS: 'success',
        WARN: 'warn',
        ERROR: 'error',
        INFO: 'info',
      };
      const severity = map[push.severidade] || 'info';
      toast.current.show({ severity, summary: 'Fatura de cancelamento', detail: push.mensagem, sticky: true });
    }
  }

  const socketRef = useRef<WebSocket | null>(null);
  const reconnectTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const reconnectAttempts = useRef(0);
  const maxReconnectAttempts = 10;
  const reconnectDelay = 3000; // 3 segundos

  const connectWebSocket = () => {
    if (!state?.token) return;

    const wsUrl = process.env.REACT_APP_API?.toString().replace('http', 'ws') + '/websocket/' + state.token;
    const socket = new WebSocket(wsUrl);
    socketRef.current = socket;

    socket.addEventListener("open", () => {
      console.log("WebSocket conectado");
      reconnectAttempts.current = 0;
    });

    socket.addEventListener("message", event => {
      const push = JSON.parse(event.data);
      if(push.tipoPush === 'RELATORIO'){
        processRelatorioNotificacao(push);
      }
      if(push.tipoPush === 'SALDO'){
        processSaldoNotificacao(push, false);
      }
      if(push.tipoPush === 'SALDO_REGISTRADO'){
        processSaldoNotificacao(push, true);
      }
      if(push.tipoPush === 'DEGUSTACAO'){
        window.dispatchEvent(new Event('degustacaoAtualizar'));
      }
      if(push.tipoPush === 'FATURA_CANCELAMENTO'){
        processFaturaCancelamentoNotificacao(push);
      }
    });

    socket.addEventListener("close", (event) => {
      console.log("WebSocket desconectado", event.code, event.reason);
      socketRef.current = null;
      
      // Reconectar apenas se não foi um fechamento intencional e não excedeu tentativas
      if (reconnectAttempts.current < maxReconnectAttempts && state?.token) {
        reconnectAttempts.current += 1;
        console.log(`Tentando reconectar... Tentativa ${reconnectAttempts.current}/${maxReconnectAttempts}`);
        
        reconnectTimeoutRef.current = setTimeout(() => {
          connectWebSocket();
        }, reconnectDelay);
      }
    });

    socket.addEventListener("error", (error) => {
      console.error("Erro no WebSocket:", error);
    });
  };

  useEffect(
    () => {
      if (state?.token && !initialized.current) {
        initialized.current = true;
        connectWebSocket();
      }

      // Cleanup ao desmontar
      return () => {
        if (reconnectTimeoutRef.current) {
          clearTimeout(reconnectTimeoutRef.current);
        }
        if (socketRef.current) {
          socketRef.current.close();
        }
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  
  

    
  http.interceptors.request.use(
    function (config) {
      
      
      if(!config.headers.ignoreLoading){
        loadingCount = loadingCount + 1
        setLoading(true)
      }
        
      
      
      
      return { ...config, headers: config.headers }
    },
    function (error) {
      loadingCount = loadingCount - 1
      if(loadingCount < 0)
        loadingCount = 0;
      if (loadingCount === 0) {
        setLoading(false)
      }
      return Promise.reject(error)
    }
  )

  http.interceptors.response.use(
    function (response) {
     
        loadingCount = loadingCount - 1
        if(loadingCount < 0)
          loadingCount = 0;
        if (loadingCount === 0) {
          setLoading(false)
        }
      
      

      return response
    },
    function (error) {
      loadingCount = loadingCount - 1
      if(loadingCount < 0)
        loadingCount = 0;
      if (loadingCount === 0) {
        setLoading(false)
      }
      return Promise.reject(error)
    }
   

  )
  return (
    <div className="App">
      <Toast ref={toast} />
      <PrimeReactProvider>
        <GlobalStateProvider>
          <GlobalState></GlobalState>
          <LoadingIndicator isLoading={loading}></LoadingIndicator>
          <RouterCustom></RouterCustom>
        </GlobalStateProvider>
      </PrimeReactProvider>
    </div>
  );
}

export default App;
